import { render, staticRenderFns } from "./ShoppingCartNote.vue?vue&type=template&id=2b46f282&scoped=true&"
import script from "./ShoppingCartNote.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartNote.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartNote.vue?vue&type=style&index=0&id=2b46f282&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b46f282",
  null
  
)

export default component.exports